import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../_base/crud';
import { Reason } from '../_models/reason.model';
import { FollowupReason } from '../_models/followup-reason.model';
import {
  FollowupReasonActions,
  FollowupReasonActionTypes,
} from '../_actions/followup-reason.actions';

// tslint:disable-next-line:no-empty-interface
export interface FollowupReasonsState extends EntityState<FollowupReason> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedFollowupReasonId: number;
  lastCreatedFollowupReason: Reason;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<FollowupReason> = createEntityAdapter<FollowupReason>();

export const initialFollowupReasonsState: FollowupReasonsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedFollowupReasonId: undefined,
  lastCreatedFollowupReason: undefined,
  showInitWaitingMessage: true,
});

export function followupReasonsReducer(
  state = initialFollowupReasonsState,
  action: FollowupReasonActions,
): FollowupReasonsState {
  switch (action.type) {
    case FollowupReasonActionTypes.FollowupReasonsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedFollowupReasonId: undefined,
      };
    case FollowupReasonActionTypes.FollowupReasonsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case FollowupReasonActionTypes.FollowupReasonDeleted:
      return adapter.removeOne(action.payload.id, state);
    case FollowupReasonActionTypes.FollowupReasonsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case FollowupReasonActionTypes.FollowupReasonsPageLoaded: {
      return adapter.addMany(action.payload.reasons, {
        ...initialFollowupReasonsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case FollowupReasonActionTypes.ThrowFollowupReasonError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case FollowupReasonActionTypes.FireFollowupReasonSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getFollowupReasonState =
  createFeatureSelector<FollowupReasonsState>('FollowupReasons');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
